(function() {
  'use strict';

  /* ═══════════════════════════════════════════════════════════════════════════
     MICRO-INTERACTIONS - JavaScript Enhancements
     ═══════════════════════════════════════════════════════════════════════════ */

  const MicroInteractions = {

    /* ─────────────────────────────────────────────────────────────────────────
       1. ADD TO CART - Enhanced Animation
       ───────────────────────────────────────────────────────────────────────── */
    initAddToCart: function() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-add-to-cart-button], .main-product__add-button, .quick-view-modal__add-btn');
        if (!btn || btn.disabled) return;

        // Add ripple class
        btn.classList.add('is-adding');

        // Create confetti particles
        this.createConfetti(btn);

        // Listen for success (cart updated)
        setTimeout(() => {
          btn.classList.remove('is-adding');
        }, 600);
      });

      // Listen for successful cart additions
      document.addEventListener('cart:updated', (e) => {
        const btn = document.querySelector('.main-product__add-button, [data-add-to-cart-button]');
        if (btn) {
          btn.classList.add('is-success');
          setTimeout(() => btn.classList.remove('is-success'), 1500);
        }
      });
    },

    createConfetti: function(btn) {
      const colors = ['#FF4D4D', '#FFD700', '#22c55e', '#3B82F6', '#A855F7'];
      const rect = btn.getBoundingClientRect();

      for (let i = 0; i < 12; i++) {
        const particle = document.createElement('span');
        particle.className = 'btn-confetti';
        particle.style.cssText = `
          left: ${rect.left + rect.width / 2}px;
          top: ${rect.top + rect.height / 2}px;
          background: ${colors[Math.floor(Math.random() * colors.length)]};
          --tx: ${(Math.random() - 0.5) * 120}px;
          --ty: ${(Math.random() - 0.5) * 80 - 40}px;
          position: fixed;
          z-index: 9999;
        `;
        document.body.appendChild(particle);
        setTimeout(() => particle.remove(), 600);
      }
    },

    /* ─────────────────────────────────────────────────────────────────────────
       2. CART ICON - Bounce Animation
       ───────────────────────────────────────────────────────────────────────── */
    initCartBounce: function() {
      // Store original count
      let lastCount = parseInt(document.querySelector('[data-cart-count]')?.textContent) || 0;

      // Watch for cart updates
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const countEl = document.querySelector('[data-cart-count]');
            const cartBtn = document.querySelector('[data-header-cart], .header__icon--cart');

            if (countEl) {
              const newCount = parseInt(countEl.textContent) || 0;
              if (newCount !== lastCount) {
                // Animate count badge
                countEl.classList.add('bounce');
                setTimeout(() => countEl.classList.remove('bounce'), 500);

                // Shake cart button
                if (cartBtn) {
                  cartBtn.classList.add('shake');
                  setTimeout(() => cartBtn.classList.remove('shake'), 400);
                }

                lastCount = newCount;

                // Dispatch custom event
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: newCount } }));
              }
            }
          }
        });
      });

      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        observer.observe(cartCount, { childList: true, characterData: true, subtree: true });
      }
    },

    /* ─────────────────────────────────────────────────────────────────────────
       3. QUANTITY SELECTOR - Number Animation
       ───────────────────────────────────────────────────────────────────────── */
    initQuantityAnimation: function() {
      document.addEventListener('click', (e) => {
        const minusBtn = e.target.closest('[data-quantity-minus], .main-product__quantity-btn:first-child, .fs-cart-item__qty-btn:first-child');
        const plusBtn = e.target.closest('[data-quantity-plus], .main-product__quantity-btn:last-child, .fs-cart-item__qty-btn:last-child');

        if (minusBtn || plusBtn) {
          const wrapper = e.target.closest('.main-product__quantity-wrapper, .fs-cart-item__qty, .quick-view-modal__quantity-selector');
          const input = wrapper?.querySelector('input, [data-quantity-input], .fs-cart-item__qty-value');

          if (input) {
            input.classList.add('pulse');
            if (plusBtn) input.classList.add('qty-slide-up');
            if (minusBtn) input.classList.add('qty-slide-down');

            setTimeout(() => {
              input.classList.remove('pulse', 'qty-slide-up', 'qty-slide-down');
            }, 200);
          }
        }
      });
    },

    /* ─────────────────────────────────────────────────────────────────────────
       7. NEWSLETTER - Success Animation
       ───────────────────────────────────────────────────────────────────────── */
    initNewsletter: function() {
      const forms = document.querySelectorAll('.newsletter-form, .fs-newsletter__form, [data-newsletter-form], form[action*="newsletter"]');

      forms.forEach(form => {
        form.addEventListener('submit', function(e) {
          const btn = this.querySelector('button[type="submit"], .newsletter-form__button, .fs-newsletter__button');
          if (btn) {
            btn.classList.add('is-loading');
          }
        });
      });
    },

    /* ─────────────────────────────────────────────────────────────────────────
       13. STICKY BAR - Scroll Detection
       ───────────────────────────────────────────────────────────────────────── */
    initStickyBar: function() {
      const stickyBar = document.querySelector('.sticky-product-bar, .main-product__sticky, [data-sticky-bar]');
      const triggerElement = document.querySelector('.main-product__add-button, [data-add-to-cart-button]');

      if (!stickyBar || !triggerElement) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else {
            stickyBar.classList.add('is-visible');
          }
        });
      }, { threshold: 0 });

      observer.observe(triggerElement);
    },

    /* ─────────────────────────────────────────────────────────────────────────
       FORM VALIDATION FEEDBACK
       ───────────────────────────────────────────────────────────────────────── */
    initFormValidation: function() {
      document.addEventListener('blur', (e) => {
        if (e.target.matches('input[required], textarea[required]')) {
          const field = e.target.closest('.form-field, .fs-form__field, [data-form-field]') || e.target.parentElement;

          if (e.target.validity.valid && e.target.value.trim()) {
            field.classList.remove('is-error', 'form-field--error', 'fs-form__field--error');
            field.classList.add('is-valid', 'form-field--valid', 'fs-form__field--valid');
          } else if (e.target.value.trim()) {
            field.classList.remove('is-valid', 'form-field--valid', 'fs-form__field--valid');
            field.classList.add('is-error', 'form-field--error', 'fs-form__field--error');
          }
        }
      }, true);
    },

    /* ─────────────────────────────────────────────────────────────────────────
       INTERSECTION OBSERVER FOR ANIMATIONS
       ───────────────────────────────────────────────────────────────────────── */
    initScrollAnimations: function() {
      const animatedElements = document.querySelectorAll('.stagger-in, [data-animate-in]');

      if (!animatedElements.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      animatedElements.forEach(el => observer.observe(el));
    },

    /* ─────────────────────────────────────────────────────────────────────────
       INITIALIZE ALL
       ───────────────────────────────────────────────────────────────────────── */
    init: function() {
      // Wait for DOM ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initAll());
      } else {
        this.initAll();
      }
    },

    initAll: function() {
      this.initAddToCart();
      this.initCartBounce();
      this.initQuantityAnimation();
      this.initNewsletter();
      this.initStickyBar();
      this.initFormValidation();
      this.initScrollAnimations();

      console.log('Micro-interactions initialized');
    }
  };

  // Initialize
  MicroInteractions.init();

  // Expose globally
  window.FullSend = window.FullSend || {};
  window.FullSend.MicroInteractions = MicroInteractions;

})();
